<template>
	<div>
		<div v-for="album in albums" :key="album.slug">
			{{album.name}} {{episodes.length}}
			<div>
				<h1><a href="route('albums.show', album.slug)" :title="album.name">{{album.name}}</a></h1>
			</div>
		</div>
	</div>
</template>
<script>
'use strict';
export default {
	name: 'albums-index',
	data() {
		return {
			albums: [],
		};
	},
	methods: {

	},
  metaInfo() {
    return {
      title: this.$t('albums'),
    };
  },
};

</script>
<style lang="css" scoped>


</style>
